import { SVGProps } from 'react'

const AudioIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M33.0007 24.424V23C33.0007 20.6131 32.0525 18.3239 30.3646 16.636C28.6768 14.9482 26.3876 14 24.0007 14C21.6137 14 19.3245 14.9482 17.6367 16.636C15.9489 18.3239 15.0007 20.6131 15.0007 23V24.424C13.9518 24.8858 13.0935 25.694 12.5693 26.7131C12.0451 27.7322 11.8869 28.9004 12.1212 30.0222C12.3555 31.1441 12.9681 32.1513 13.8564 32.8755C14.7446 33.5996 15.8547 33.9966 17.0007 34C17.5311 34 18.0398 33.7893 18.4149 33.4142C18.79 33.0391 19.0007 32.5304 19.0007 32V26C19.0007 25.4696 18.79 24.9609 18.4149 24.5858C18.0398 24.2107 17.5311 24 17.0007 24V23C17.0007 21.1435 17.7382 19.363 19.0509 18.0503C20.3637 16.7375 22.1442 16 24.0007 16C25.8572 16 27.6377 16.7375 28.9504 18.0503C30.2632 19.363 31.0007 21.1435 31.0007 23V24C30.4702 24 29.9615 24.2107 29.5865 24.5858C29.2114 24.9609 29.0007 25.4696 29.0007 26V32C29.0007 32.5304 29.2114 33.0391 29.5865 33.4142C29.9615 33.7893 30.4702 34 31.0007 34C32.1467 33.9966 33.2568 33.5996 34.145 32.8755C35.0333 32.1513 35.6458 31.1441 35.8801 30.0222C36.1144 28.9004 35.9562 27.7322 35.4321 26.7131C34.9079 25.694 34.0495 24.8858 33.0007 24.424Z"
        fill="#7181FF"
      />
    </svg>
  )
}

export default AudioIcon
